/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import isEmpty from "lodash/isEmpty";
import { useRouter } from "next/router";
import {
  Loader as CardsPlaceHolder,
  Button,
  Image,
} from "@gonoodle/gn-universe-ui";
import { concatenateQueryParams, invariant } from "@gonoodle/gn-universe-utils";
import { get } from "lodash";
import {
  SECTIONS,
  SECTIONS_TYPES,
} from "@gonoodle/gn-universe-analytics-schema/src/constants";
import {
  HeartIcon as HeartIconOutline,
  ClockIcon as ClockIconOutline,
} from "@heroicons/react/outline";

import { twMerge } from "tailwind-merge";
import { useCurrentChampion, useProfile } from "../../../../hooks";
import { useDataLoader } from "../../hooks";
import VideoTile from "../../../VideoTile";
import PrintableTile from "../../../PrintableTile";
import TextTile from "../../../TextTile";
import CustomLinkCardTile from "../../../CustomLinkCardTile";
import BlogCardTile from "../../../BlogCardTile";
import {
  CONTENT_TYPES,
  ROUTE_PREFIX,
  ROUTE_PATHS,
  PROFILE_TYPES,
} from "../../../../constants";
import { getSourcePageAndSourcePageTypeFromReferrer } from "../../../../utils/analytics";
import { useUser } from "../../../../contexts/user";

const JSURL = require("jsurl");

const ThunderIcon = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 48096263">
      <g id="Group">
        <path
          id="Vector"
          d="M6.41305 7.64258C6.97686 7.64258 7.5426 7.64258 8.10641 7.64258C8.11413 7.64258 8.12379 7.64258 8.13151 7.64258C8.16434 7.64258 8.16627 7.64468 8.15082 7.67626C8.13151 7.72046 8.11027 7.76466 8.09096 7.80676C8.02338 7.95411 7.9558 8.10146 7.88822 8.25091C7.8805 8.26775 7.87278 8.28248 7.85154 8.27827C7.83416 8.27406 7.82837 8.2909 7.82064 8.30353C7.78782 8.36457 7.75499 8.42772 7.72217 8.48877C7.64107 8.64243 7.56191 8.79398 7.48081 8.94764C7.41709 9.06973 7.35338 9.19182 7.28966 9.31601C7.21822 9.45073 7.14871 9.58755 7.07726 9.72227C7.01161 9.84856 6.94597 9.97275 6.88032 10.0991C6.81081 10.2317 6.74129 10.3622 6.67178 10.4948C6.59841 10.6337 6.52697 10.7726 6.4536 10.9137C6.37636 11.061 6.29913 11.2084 6.22189 11.3536C6.15624 11.4778 6.09253 11.602 6.02688 11.7262C5.97281 11.8293 5.91875 11.9346 5.86469 12.0377C5.85889 12.0482 5.84924 12.0567 5.8531 12.0714C5.84731 12.0714 5.84538 12.0777 5.84345 12.0819C5.83379 12.0945 5.82414 12.1072 5.81448 12.1177C5.24681 12.7365 4.67914 13.3554 4.11147 13.9764C4.10567 13.9827 4.09795 13.9911 4.0883 13.9995C4.08444 13.9806 4.09409 13.9679 4.09795 13.9553C4.36055 13.2375 4.62508 12.5197 4.88767 11.802C5.28543 10.7158 5.68512 9.62965 6.08287 8.54349C6.18907 8.25091 6.2972 7.96043 6.40339 7.66784C6.40919 7.66152 6.41112 7.651 6.41305 7.64258Z"
          fill="#18181B"
        />
        <path
          id="Vector_2"
          d="M6.41111 0.00390625C6.42269 0.00390625 6.43428 0.00390625 6.44586 0.00390625C7.78588 0.00390625 9.12589 0.00390625 10.464 0.00390625C10.4756 0.00390625 10.4871 0.00390625 10.5045 0.00390625C9.33635 1.70049 8.17205 3.39497 7.00195 5.09367C8.75517 5.09367 10.5007 5.09367 12.25 5.09367C12.2481 5.11051 12.2365 5.11682 12.2288 5.12524C11.3329 6.10194 10.4389 7.07863 9.54296 8.05533C8.32265 9.38565 7.10235 10.716 5.88205 12.0484C5.87433 12.0568 5.86853 12.0674 5.85695 12.0737C5.85309 12.0589 5.86274 12.0505 5.86853 12.04C5.9226 11.9368 5.97666 11.8337 6.03073 11.7285C6.09638 11.6043 6.16009 11.4801 6.22574 11.3559C6.30298 11.2085 6.38021 11.0612 6.45745 10.9159C6.53082 10.777 6.60226 10.6381 6.67563 10.4971C6.74514 10.3645 6.81465 10.2339 6.88417 10.1013C6.94981 9.97714 7.01546 9.85085 7.08111 9.72455C7.15255 9.58983 7.22207 9.45301 7.29351 9.31829C7.35723 9.19621 7.42094 9.07412 7.48466 8.94993C7.56383 8.79627 7.64492 8.64471 7.72602 8.49105C7.75884 8.4279 7.79167 8.36686 7.82449 8.30582C7.83029 8.29319 7.83801 8.27845 7.85539 8.28056C7.87663 8.28477 7.88435 8.27003 7.89207 8.25319C7.95965 8.10585 8.02723 7.9585 8.09481 7.80905C8.11412 7.76484 8.13536 7.72064 8.15467 7.67854C8.16819 7.64697 8.16625 7.64486 8.13536 7.64486C8.12764 7.64486 8.11798 7.64486 8.11026 7.64486C7.54645 7.64486 6.98071 7.64486 6.4169 7.64486C6.40338 7.64486 6.38987 7.64486 6.37635 7.64486C5.43216 7.64486 4.48797 7.64486 3.54378 7.64486C3.53027 7.64486 3.51675 7.64486 3.50323 7.64276C3.53413 7.56066 3.56502 7.47647 3.59785 7.39437C3.65577 7.24492 3.7137 7.09547 3.77162 6.94602C3.8392 6.7671 3.90678 6.58607 3.97629 6.40715C4.04774 6.21981 4.12111 6.03247 4.19255 5.84513C4.26785 5.64937 4.3393 5.45361 4.4146 5.25996C4.49183 5.05578 4.571 4.8537 4.65016 4.64952C4.71967 4.4706 4.78532 4.28958 4.85483 4.11066C4.93786 3.89385 5.02089 3.67704 5.10392 3.46023C5.18887 3.23921 5.2719 3.02029 5.35686 2.79928C5.46112 2.52563 5.56539 2.25409 5.66966 1.98045C5.77006 1.71523 5.8724 1.45211 5.9728 1.18689C6.04617 0.993231 6.12148 0.799576 6.19485 0.605921C6.25664 0.441735 6.32036 0.279654 6.38214 0.115468C6.38794 0.0754744 6.40917 0.0439002 6.41111 0.00390625Z"
          fill="#FFB81C"
        />
        <path
          id="Vector_3"
          d="M6.41109 0.00420989C6.40916 0.0442039 6.38792 0.077883 6.37633 0.111562C6.31455 0.275748 6.25276 0.439934 6.18904 0.602015C6.11567 0.79567 6.04036 0.989325 5.96699 1.18298C5.86659 1.4482 5.76425 1.71132 5.66385 1.97654C5.55958 2.25019 5.45532 2.52173 5.35105 2.79537C5.26609 3.01639 5.18306 3.2353 5.09811 3.45632C5.01508 3.67313 4.93205 3.88994 4.84903 4.10675C4.78145 4.28567 4.71387 4.4667 4.64435 4.64562C4.56712 4.8498 4.48796 5.05187 4.40879 5.25605C4.33349 5.45181 4.26205 5.64757 4.18674 5.84123C4.1153 6.02857 4.04193 6.21591 3.97049 6.40325C3.90291 6.58217 3.83533 6.76319 3.76582 6.94211C3.70789 7.09157 3.64996 7.24102 3.59204 7.39047C3.56114 7.47256 3.53025 7.55676 3.49743 7.63885C3.48777 7.63885 3.47812 7.64096 3.47039 7.64096C2.90658 7.64096 2.34277 7.64096 1.77896 7.64096C1.77124 7.64096 1.76159 7.64096 1.75386 7.63885C1.75193 7.63675 1.75 7.63675 1.75 7.63464C1.78089 7.5336 1.82337 7.43888 1.86006 7.33995C2.13038 6.63058 2.4007 5.92332 2.67102 5.21395C2.93168 4.53406 3.19042 3.85416 3.45109 3.17426C3.78319 2.30702 4.1153 1.43768 4.44548 0.570441C4.51499 0.389415 4.5845 0.206285 4.65401 0.0252594C4.66173 0.00631484 4.66946 0 4.68876 0C5.25837 0 5.82797 0 6.3995 0C6.40337 0.00210495 6.40723 0.00420989 6.41109 0.00420989Z"
          fill="#18181B"
        />
        <path
          id="Vector_4"
          d="M5.84534 12.0858C5.84534 12.0789 5.84766 12.0742 5.85696 12.0742C5.85464 12.0789 5.85231 12.0835 5.84534 12.0858Z"
          fill="#FFB81C"
        />
        <path
          id="Vector_5"
          d="M1.75 7.63867C1.75195 7.64064 1.75391 7.64064 1.75391 7.6426C1.75 7.6426 1.75 7.6426 1.75 7.63867Z"
          fill="#FFB81C"
        />
      </g>
    </g>
  </svg>
);

const PLACEHOLDER_TYPES = {
  PROMPT_ADD_TO_FAVORITES: "promptAddToFavorites",
  PROMPT_START_WATCHING: "promptStartWatching",
  PROMPT_SIGNUP_OR_LOGIN_TO_TRACK_HISTORY: "promptSignUpOrLogInToTrackHistory",
  PROMPT_SIGNUP_OR_LOGIN_TO_SAVE_FAVORITES:
    "promptSignUpOrLogInToSaveFavorites",
};

export default function CardList({ templateOptions, fetchers }) {
  const {
    title,
    displayTitle,
    description,
    placeholder = {},
    size,
  } = templateOptions;
  const { user } = useUser();
  const { profile } = useProfile();
  const [fetcher] = fetchers;
  const { data, isLoading } = useDataLoader(fetcher);
  const { contentType, content: cards = [] } = get(data, "[0]", {});
  const numberOfCards = cards.length;
  let gridColumnsClasses = undefined;
  let includeViewFavoritesButton = false;
  const showClassCard = user.features?.classCard && size === 3 && profile;

  if (numberOfCards === 5) {
    gridColumnsClasses = "grid-cols-2 lg:grid-cols-3 xl:grid-cols-5";
  } else if (showClassCard) {
    gridColumnsClasses = "md:grid-cols-2 lg:grid-cols-3";
  } else {
    gridColumnsClasses = "md:grid-cols-2 lg:grid-cols-4";
  }

  if (isLoading) {
    return (
      <div className="grid gap-x-md gap-y-md md:grid-cols-2 lg:grid-cols-4">
        <CardsPlaceHolder cols={4} size="short" mode="dark" />
      </div>
    );
  }

  invariant(
    !(isLoading === false && numberOfCards > 5),
    `CardList: Invalid number of cards expected between 1 and 5 got ${numberOfCards}`,
  );

  if (placeholder.type === PLACEHOLDER_TYPES.PROMPT_ADD_TO_FAVORITES) {
    if (numberOfCards === 0) {
      return (
        <PromptAddToFavorites
          displayTitle={displayTitle}
          description={description}
        />
      );
    }

    includeViewFavoritesButton = true;
  }

  if (
    numberOfCards === 0 &&
    placeholder.type === PLACEHOLDER_TYPES.PROMPT_START_WATCHING
  ) {
    return (
      <PromptStartWatching
        displayTitle={displayTitle}
        description={description}
      />
    );
  }

  if (
    numberOfCards === 0 &&
    placeholder.type ===
      PLACEHOLDER_TYPES.PROMPT_SIGNUP_OR_LOGIN_TO_TRACK_HISTORY
  ) {
    return (
      <PromptSignUpOrLogInToTrackHistory
        displayTitle={displayTitle}
        description={description}
      />
    );
  }

  if (
    numberOfCards === 0 &&
    placeholder.type ===
      PLACEHOLDER_TYPES.PROMPT_SIGNUP_OR_LOGIN_TO_SAVE_FAVORITES
  ) {
    return (
      <PromptSignUpOrLogInToSaveFavorites
        displayTitle={displayTitle}
        description={description}
      />
    );
  }

  return (
    <div className="flex">
      <div className={twMerge("w-full", showClassCard ? "lg:w-3/4" : "")}>
        {showClassCard ? <ClassCardItem className="flex lg:hidden" /> : null}
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            <h2 className="gn-text font-bold text-gray-200 capitalize mb-1">
              {displayTitle || title}
            </h2>
            <p className="gn-text-sm text-white mb-5">{description}</p>
          </div>
          {includeViewFavoritesButton && <ViewFavoritesButton />}
        </div>
        <ul className={`grid gap-x-md gap-y-md ${gridColumnsClasses}`}>
          {cards.map((card, index) =>
            showClassCard && index === 3 ? null : contentType ===
                CONTENT_TYPES.TAGS ||
              [
                CONTENT_TYPES.TOPIC,
                CONTENT_TYPES.CHANNEL,
                CONTENT_TYPES.TAG,
              ].includes(card.contentType) ? (
              <TextListItem
                key={`${card.id}_${index}`}
                card={card.content ? card.content : card}
                format={card.content ? "landscape" : "square"}
                title={title}
              />
            ) : contentType === CONTENT_TYPES.VIDEOS ||
              card.contentType === CONTENT_TYPES.VIDEO ? (
              <VideoListItem
                key={`${card.id}_${index}`}
                card={card.content || card}
                title={title}
              />
            ) : contentType === CONTENT_TYPES.ACTIVITIES ||
              card.contentType === CONTENT_TYPES.ACTIVITY ? (
              <PrintableListItem
                key={`${card.id}_${index}`}
                card={card.content || card}
                format={card.content ? "landscape" : "portrait"}
                title={title}
              />
            ) : card.contentType === CONTENT_TYPES.CUSTOM_LINK ? (
              <LinkCardListItem
                key={`${card.id}_${index}`}
                card={card.content}
                title={title}
              />
            ) : card.contentType === CONTENT_TYPES.BLOG_POST ? (
              <BlogPostListItem
                key={`${card.id}_${index}`}
                card={card.content}
                title={title}
              />
            ) : null,
          )}

          {cards.length < 4 &&
            Array.from({ length: 4 - cards.length }).map((_, index) => (
              <PlaceHolderListItem key={index} placeholder={placeholder} />
            ))}
        </ul>
      </div>
      {showClassCard ? (
        <ClassCardItem className="hidden flex-grow lg:flex flex-col border-l-[1px] border-gray-500 w-1/4 mx-auto pl-12" />
      ) : null}
    </div>
  );
}
function ViewFavoritesButton() {
  const router = useRouter();
  return (
    <Button
      size="sm"
      variant="light-outline"
      className="capitalize space-x-2 whitespace-nowrap"
      onPress={() => router.push(`/${ROUTE_PREFIX.FAVORITES}`)}
    >
      <HeartIconOutline className="h-5" />
      <span>view favorites</span>
    </Button>
  );
}

const getTile = (card, format) => {
  // card.image is used when Card is in a Custom Shelf AND is not a Tag Card
  if (card.image) return card.image;

  // this is used when card is a Tag Card in a Custom Shelf
  if (format === "landscape") {
    if (card.images?.spotlightImage) return card.images.spotlightImage;
    if (card.images?.tileImage) return card.images.tileImage;
  }

  // this is used when card is a content Tag Card in a content Tag Shelf
  if (card.images?.tileImage) return card.images.tileImage;
  if (card.images?.spotlightImage) return card.images.spotlightImage;

  return null;
};

function TextListItem({ card, format, title }) {
  const router = useRouter();
  const tile = getTile(card, format);

  return (
    <li className="flex flex-col justify-top relative">
      <TextTile
        id={card.id}
        slug={card.slug}
        name={card.name}
        title={card.name}
        description={card.description}
        tile={tile}
        format={format}
        linkParams={{
          sourceElement: SECTIONS_TYPES.SHELF,
          sourceName: title,
          ...getSourcePageAndSourcePageTypeFromReferrer(
            router.pathname,
            router.query,
          ),
        }}
      />
    </li>
  );
}

function VideoListItem({ card, title }) {
  const router = useRouter();
  return (
    <li className="flex flex-col justify-top relative group">
      <VideoTile
        id={card.id}
        slug={card.slug}
        title={card.title}
        description={card.description}
        images={card.images}
        duration={card.duration}
        sponsor={{
          expiration: card.attribution?.expiration,
          type: card.attribution?.type,
        }}
        impressionsProps={
          card?.partner?.partnerId
            ? {
                partnerName: card.partner.partnerName,
                partnerId: card.partner.partnerId,
                sourceElement: SECTIONS_TYPES.SHELF,
                sourceName: title,
                ...getSourcePageAndSourcePageTypeFromReferrer(
                  router.pathname,
                  router.query,
                ),
              }
            : null
        }
        linkParams={{
          sourceElement: SECTIONS_TYPES.SHELF,
          sourceName: title,
          ...getSourcePageAndSourcePageTypeFromReferrer(
            router.pathname,
            router.query,
          ),
        }}
      />
    </li>
  );
}

function PrintableListItem({ card, title, format }) {
  const router = useRouter();
  const sources =
    format === "landscape" && !isEmpty(card.heroImage)
      ? {
          "regular@1x": card.heroImage["thumb@1x"],
          "regular@2x": card.heroImage["thumb@2x"],
          "regular@3x": card.heroImage["thumb@3x"],
        }
      : card.image;
  return (
    <li className="flex flex-col justify-top relative group">
      <PrintableTile
        id={card.id}
        slug={card.slug}
        mode="dark"
        sources={sources}
        title={card.title}
        description={card.description}
        format={format}
        linkParams={{
          sourceElement: SECTIONS_TYPES.SHELF,
          sourceName: title,
          ...getSourcePageAndSourcePageTypeFromReferrer(
            router.pathname,
            router.query,
          ),
        }}
      />
    </li>
  );
}

function LinkCardListItem({ card, title }) {
  const router = useRouter();
  const {
    id,
    slug,
    name,
    description,
    image,
    images,
    title: customLinkTitle,
    destinationUrl,
  } = card;
  return (
    <li className="flex flex-col justify-top relative group">
      <CustomLinkCardTile
        id={id}
        slug={slug}
        sources={images?.spotlightImage || image}
        title={name}
        name={name}
        customLinkTitle={customLinkTitle}
        destinationUrl={destinationUrl}
        description={description}
        format="landscape"
        linkParams={{
          sourceElement: SECTIONS_TYPES.SHELF,
          sourceName: title,
          ...getSourcePageAndSourcePageTypeFromReferrer(
            router.pathname,
            router.query,
          ),
        }}
      />
    </li>
  );
}

function BlogPostListItem({ card, title }) {
  const router = useRouter();
  const { slug, title: blogTitle, description, images } = card;

  return (
    <li className="flex flex-col justify-top relative group">
      <BlogCardTile
        slug={slug}
        title={title}
        name={blogTitle}
        description={description}
        imageUrl={images.tile}
        analyticsProps={{
          sourceElement: SECTIONS_TYPES.SHELF,
          sourceName: title,
          ...getSourcePageAndSourcePageTypeFromReferrer(
            router.pathname,
            router.query,
          ),
        }}
      />
    </li>
  );
}

function PromptAddToFavorites({ displayTitle, description }) {
  return (
    <div className="flex flex-col space-y-5">
      <div className="flex flex-row justify-between space-x-1">
        <div>
          <h2 className="gn-text font-bold text-gray-200 capitalize mb-1">
            {displayTitle}
          </h2>

          <p className="gn-text-sm text-white">{description}</p>
        </div>

        <div className="mt-auto">
          <ViewFavoritesButton />
        </div>
      </div>

      <div className="bg-gray-800 w-full flex flex-col justify-center items-center space-y-10 py-16 px-1 text-center">
        <HeartIconOutline
          className="w-32 h-32 text-gray-100"
          aria-hidden="true"
        />

        <span className="text-lg text-gray-100">
          You have no favorited videos
        </span>
      </div>
    </div>
  );
}

function PromptStartWatching({ displayTitle, description }) {
  return (
    <div className="flex flex-col space-y-5">
      <div>
        <h2 className="gn-text font-bold text-gray-200 capitalize mb-1">
          {displayTitle}
        </h2>

        <p className="gn-text-sm text-white">{description}</p>
      </div>

      <div className="bg-gray-800 w-full flex flex-col justify-center items-center space-y-10 py-16 px-1 text-center">
        <ClockIconOutline
          className="w-32 h-32 text-gray-100"
          aria-hidden="true"
        />

        <span className="text-lg text-gray-100">Watch some videos</span>
      </div>
    </div>
  );
}

function PromptSignUpOrLogInToTrackHistory({ displayTitle, description }) {
  const router = useRouter();

  return (
    <div className="flex flex-col space-y-5">
      <div>
        <h2 className="gn-text font-bold text-gray-200 capitalize mb-1">
          {displayTitle}
        </h2>

        <p className="gn-text-sm text-white">{description}</p>
      </div>

      <div className="bg-gray-800 w-full flex flex-col justify-center items-center space-y-10 py-16 px-1 text-center">
        <ClockIconOutline
          className="w-32 h-32 text-gray-100"
          aria-hidden="true"
        />

        <span className="text-lg text-gray-100">
          Create a free account to start seeing your recently watched videos
          here!
        </span>

        <Button
          variant="light"
          size="sm"
          className="font-regular lg:whitespace-nowrap"
          onPress={() =>
            router.push(
              concatenateQueryParams(ROUTE_PATHS.REGISTRATION, {
                referrer: JSURL.stringify({
                  pathname: router.pathname,
                  query: router.query,
                  sourceElement: SECTIONS_TYPES.RECENTLY_WATCHED_SHELF,
                  sourceName: SECTIONS.CREATE_ACCOUNT_BUTTON,
                }),
              }),
              ROUTE_PATHS.REGISTRATION,
            )
          }
        >
          Create a Free Account
        </Button>
      </div>
    </div>
  );
}

function PromptSignUpOrLogInToSaveFavorites({ displayTitle, description }) {
  const router = useRouter();

  return (
    <div className="flex flex-col space-y-5">
      <div>
        <h2 className="gn-text font-bold text-gray-200 capitalize mb-1">
          {displayTitle}
        </h2>

        <p className="gn-text-sm text-white">{description}</p>
      </div>

      <div className="bg-gray-800 w-full flex flex-col justify-center items-center space-y-10 py-16 px-1 text-center">
        <HeartIconOutline
          className="w-28 h-28 text-gray-100"
          aria-hidden="true"
        />

        <span className="text-lg text-gray-100">
          Create a Free Account to start favoriting videos and see them here!
        </span>

        <Button
          variant="light"
          size="sm"
          className="font-regular lg:whitespace-nowrap"
          onPress={() =>
            router.push(
              concatenateQueryParams(ROUTE_PATHS.REGISTRATION, {
                referrer: JSURL.stringify({
                  pathname: router.pathname,
                  query: router.query,
                  sourceElement: SECTIONS_TYPES.FAVORITES_SHELF,
                  sourceName: SECTIONS.CREATE_ACCOUNT_BUTTON,
                }),
              }),
              ROUTE_PATHS.REGISTRATION,
            )
          }
        >
          Create a Free Account
        </Button>
      </div>
    </div>
  );
}

function PlaceHolderListItem({ placeholder = {} }) {
  const { type } = placeholder;

  if (!type) return null;

  return (
    <li className="flex flex-col justify-top">
      <div className="w-full bg-gray-700 transition-shadow shadow-darkSM aspect-w-16 aspect-h-9">
        {type === PLACEHOLDER_TYPES.PROMPT_START_WATCHING && (
          <div className="flex flex-col justify-center items-center p-1">
            <ClockIconOutline
              className="w-28 h-28 text-gray-100"
              aria-hidden="true"
            />

            <span className="gn-text-sm mt-xs text-gray-100 capitalize">
              Watch More Videos
            </span>
          </div>
        )}

        {type === PLACEHOLDER_TYPES.PROMPT_ADD_TO_FAVORITES && (
          <div className="flex flex-col justify-center items-center p-1">
            <HeartIconOutline
              className="w-28 h-28 text-gray-100"
              aria-hidden="true"
            />

            <span className="gn-text-sm mt-xs text-gray-100 capitalize">
              favorite more videos
            </span>
          </div>
        )}
      </div>
    </li>
  );
}

const getStreak = (profile) => {
  if (profile?.classroomType === PROFILE_TYPES.CLASSROOM) {
    return {
      primaryStreakValue: profile.weekStreak,
      primaryStreakDescription: `week`,
      secondaryStreakValue: profile.schoolYearWeekStreak,
      secondaryStreakDescription: `Week Streak in School Year`,
    };
  }
  return {
    primaryStreakValue: profile.dayStreak,
    primaryStreakDescription: `day`,
    secondaryStreakValue: profile.weekStreak,
    secondaryStreakDescription: `Week Streak`,
  };
};

function ClassCardItem({ className }) {
  const champ = useCurrentChampion();
  const { profile } = useProfile();
  const {
    primaryStreakValue,
    primaryStreakDescription,
    secondaryStreakValue,
    secondaryStreakDescription,
  } = getStreak(profile);
  const styleGradientYellow = {
    background: "linear-gradient(94deg, #F0C30F 51.36%, #F4A934 100%)",
  };
  if (!champ || !profile) return null;

  return (
    <div
      className={twMerge(
        className,
        "items-center justify-between mb-8 lg:mb-0 text-white lg:max-w-52 space-x-3 lg:space-y-3 gn-text-sm font-bold flex-auto",
      )}
    >
      <div className="flex flex-col sm:flex-row lg:flex-col w-28 md:w-fit lg:max-w-52 items-center lg:flex-grow justify-between">
        <Image
          className="h-[72px] lg:h-full w-auto lg:object-cover"
          sources={{
            "regular@1x": champ.images.full["1x"],
            "regular@2x": champ.images.full["2x"],
            "regular@3x": champ.images.full["3x"],
          }}
        />
        <span className="text-center italic font-normal text-xs md:text-sm lg:text-md">
          {champ.name}
        </span>
      </div>

      <div className="hidden md:block lg:hidden border-white border-l-2 opacity-30 h-8" />

      <div
        className="flex flex-wrap justify-center lg:justify-between items-center max-w-[78px] sm:max-w-1/3 lg:w-full lg:max-w-full px-1 py-2 sm:px-3 sm:py-[6px] lg:p-3 gap-2 text-gray-900 rounded md:rounded-xl"
        style={styleGradientYellow}
      >
        <div className="flex items-center justify-center w-[22px] h-[22px] md:h-8 md:w-8 lg:h-9 lg:w-9 p-1 md:p-2 rounded-full bg-white">
          <ThunderIcon />
        </div>
        <span className="text-[24px] font-extrabold lg:text-[36px] lg:ml-auto">
          {primaryStreakValue}
        </span>
        <span className="font-semibold text-xs md:text-md md:font-semibold lg:w-full text-center lg:text-end">
          {`${primaryStreakDescription} streak`}
        </span>
      </div>

      <div className="hidden md:block lg:hidden border-white border-l-2 opacity-30 h-8" />

      <div className="flex flex-wrap lg:flex-nowrap lg:flex-row-reverse items-center justify-center lg:justify-between w-[120px] md:w-fit lg:w-full space-x-2 lg:space-x-0 lg:pt-3 lg:border-gray-500 lg:border-t-[1px]">
        <span
          className="font-black text-transparent text-[18px]"
          style={{ ...styleGradientYellow, WebkitBackgroundClip: "text" }}
        >
          {secondaryStreakValue}
        </span>
        <span className="text-xs md:text-sm text-center lg:text-start font-medium">
          {secondaryStreakDescription}
        </span>
      </div>
    </div>
  );
}
